import {ADD_DOCUMENT} from "../types";

const addDocument= (file={front:null,back:null}) => async (dispatch) =>
{
    dispatch({type:ADD_DOCUMENT,payload:file});
};
export default addDocument;